import React from "react";
import { ArrowDown2 } from "iconsax-react";
import {
  ParentAccordion as StyledParentAccordion,
  ParentAccordionSummary,
  ParentAccordionDetails,
  SectionTitle,
} from "./styles";
import { SharedStatusBadge } from "../SharedStatusBadge";
import type { ParentAccordionProps } from "../../types";

export const ParentAccordion = ({
  title,
  icon,
  status,
  expanded,
  onToggle,
  children,
}: ParentAccordionProps) => {
  return (
    <StyledParentAccordion elevation={0} expanded={expanded} onChange={onToggle}>
      <ParentAccordionSummary expandIcon={<ArrowDown2 />}>
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          {icon}
          <SectionTitle>{title}</SectionTitle>
        </div>
        <SharedStatusBadge status={status} />
      </ParentAccordionSummary>

      <ParentAccordionDetails>{children}</ParentAccordionDetails>
    </StyledParentAccordion>
  );
};
